var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6192 11.1159V7.04479C11.6192 5.04401 11.169 3.51562 8.72862 3.51562C7.55196 3.51562 6.76756 4.12698 6.44799 4.71054H6.41894V3.69631H4.10938V11.1159H6.52068V7.43384C6.52068 6.46123 6.70946 5.53036 7.95869 5.53036C9.19345 5.53036 9.20792 6.62796 9.20792 7.48941V11.102H11.6192V11.1159Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 3.69531H2.59881V11.1149H0.1875V3.69531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39449 0C0.624615 0 0 0.597458 0 1.33386C0 2.07026 0.624615 2.68161 1.39449 2.68161C2.16436 2.68161 2.78898 2.07026 2.78898 1.33386C2.78898 0.597458 2.16436 0 1.39449 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinImg);
export default __webpack_public_path__ + "static/media/linkedin-img.f99f392a2efc523f1dfb8cf74027170c.svg";
export { ForwardRef as ReactComponent };